import React from 'react';
import store from 'javascripts/store.js';

class ReactPlaidLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasPendingClick: false,
    };
  }

  static defaultProps = {
    className: 'PlaidLink',
  }

  componentDidUpdate = () => {
    if(!this.achHandler) {
      this.configurePlaidHandler();
    }
  }

  configurePlaidHandler = () => {
    this.achHandler = window.Plaid.create(this.getConfig());
    if(this.state.hasPendingClick) {
      this.openACHHandler();
    }
  };

  getConfig = () => {
    const config = {};
    config.key = this.props.plaidKey;
    config.env = this.props.plaidEnv;
    config.apiVersion = 'v2';
    const options = [
      'clientName', 'product', 'onLoad',
      'onSuccess', 'onExit', 'webhook', 'token', 'longtail',
      'selectAccount',
    ];
    for (let i = 0; i < options.length; i++) {
      const key = options[i];
      if (key in this.props) {
        config[key] = this.props[key];
      }
    }
    return config;
  };

  openACHHandler = () => {
    this.hideLoadingDialog();
    this.achHandler.open();
  };

  showLoadingDialog = () => {
    this.props.showLoadingDialog &&
      this.props.showLoadingDialog();
  };

  hideLoadingDialog = () => {
    this.props.hideLoadingDialog &&
      this.props.hideLoadingDialog();
  };

  handleOnClickAfterExistingMembershipCheck = () => {
    if(this.achHandler) {
      this.openACHHandler();
    } else {
      this.showLoadingDialog();
      this.setState({
        hasPendingClick: true,
      });
      this.props.afterPlaidClickHandled &&
        this.props.afterPlaidClickHandled();
    }
  };

  onClick = () => {
    const plaidButtonContainer = this.link;
    const $parentForm = $(plaidButtonContainer).closest('form');
    const submitButtonDisabled = $(plaidButtonContainer).children()[0].disabled;
    const donateFormInvalid = $parentForm.length && !$parentForm.parsley().validate();

    if(donateFormInvalid || submitButtonDisabled) {
      return;
    }

    if(this.props.checkForExistingMembership) {
      $.getJSON(`/api/v1/spring_membership/${store.donateForm.email}`, (data) => {
        store.donateForm.isAlreadySpringMember = data['is_spring_member'];
        if(!data['is_spring_member']) {
          this.handleOnClickAfterExistingMembershipCheck();
        }
      });
    } else {
      this.handleOnClickAfterExistingMembershipCheck();
    }
  }

  render() {
    return (
      <span onClick={this.onClick} ref={el => this.link = el}>
        {this.props.children}
      </span>
    );
  }
}

export default ReactPlaidLink;
